module.exports = __webpack_public_path__ + "media/76.118d666d.wav";